// src/theme.js

import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#000",
    },
    error: {
      main: "#b00020",
    },
    text: {
      primary: "#000",
      secondary: "#6F6F6F",
      disabled: "#CCCCCC",
    },
    background: {
      default: "#FFF",
      primary: "#000",
      secondary: "#6F6F6F",
      highlight: "#FFF",
      info: "#F5F5F5",
    },
    action: {
      disabledBackground: "#5A87A0",
      disabled: "#B9D7E6",
    },
    link: {
      main: "#0076A9",
    },
  },
  typography: {
    fontFamily: "Inter var, sans-serif",
    h1: {
      fontSize: "30px",
      fontWeight: "normal",
      lineHeight: "normal",
      letterSpacing: "10px",
    },
  },
  breakpoints: {
    values: {
      xs: 0,      // Extra-small devices (phones)
      sm: 480,    // Small devices (portrait tablets and large phones)
      md: 768,    // Medium devices (landscape tablets)
      lg: 1024,   // Large devices (desktops)
      xl: 1440,   // Extra-large devices (large desktops)
      // xxl: 1920, // Uncomment if you add a custom breakpoint
    },
  },
});

export default theme;
